const fr = {
  message: {
    header: {
      aboutus: "Accueil",
      project: "le projet",
      team: "l'équipe",
      sponsors: "Commanditaires",
      donate: "faire un don",
      "contact-us": "Nous trouver",
      media: "média",
      pictures: "photos",
      movies: "vidéos",
      model: "Model 3D",
    },

    notifications: {
      join: "Rejoignez l'équipe",
    },

    home: {
      presentation:
        "Formule ETS est un club scientifique formé d’étudiants de l'École de technologie supérieure qui conçoit et fabrique une voiture électrique dans le but de remporter des compétitions Formula SAE et Formula Student.",
      aboutUs: {
        title: "Qui sommes nous ?",
        //text: "Formule ETS est une équipe de Formule SAE composée d'étudiants en ingénierie de l'École de technologie supérieure de Montréal. Les compétitions de la Collegiate Design Series regroupe plus de 600 équipes universitaires à travers le monde. Elles s’affrontent en présentant un plan d'affaires à des juges, en décrivant leur philosophie de conception de leur véhicule, en créant la liste des coûts du projet et bien sûr en se mesurant aux meilleures équipes de Formule SAE lors de courses palpitantes. <br><br> Nous nous sommes démarqués à plusieurs reprises dans ces compétitions en ayant le véhicule le plus léger, en démontrant une finition exemplaire et en ayant à de nombreuses reprises montées sur les marches du podium. Formule ETS conçoit des voitures de course depuis 1988, électriques depuis 2020. ",
        text: "Formule ETS est une équipe d'étudiants dans divers domaines de l'ingénierie de l'École de technologie supérieure située à Montréal. Nos prototypes sont reconnus comme complexes et avant-gardistes depuis 1988. En 2020, nous avons pris le virage de l’électrique avant de nous intéresser à la conduite autonome en 2023. Depuis plusieurs années, l’équipe se distingue dans les compétitions internationales d’ingénierie, la Formula SAE et la Formula Student. <br><br> Ces compétitions regroupent plus de 600 universités, de 46 nationalités différentes, qui s’affrontent dans des épreuves dynamiques sur la piste et statiques devant des juges. Ces dernières années, notre équipe a eu la chance de se déplacer pour des compétitions au Canada, aux États-Unis et en Europe. ",      
      },
      project: {
        title: "Le projet !",
        //text:
        //  `Formule ETS conçoit et fabrique des voitures de course dans le but de participer à des compétitions de Formule SAE depuis maintenant plus de 30 ans avec toujours le même objectif : "GAGNER" <br><br> ` +
        //  `Les véhicules qui sortent de l'atelier de la Formule ETS reflètent notre philosophie de conception. Ainsi, nous poursuivons incessamment la conception du véhicule le plus léger, année après année. <br><br>` +
        //  `Notre première voiture électrique, MANIC-20, pèse 195 kg et est propulsée par quatre moteurs AMK. MANIC est chaussée de pneu Hoosier de 16 pouces montés sur des roues en aluminium et des étriers de frein sur mesure conçus à l’interne.`,
        text:
          `Depuis plus de 35 ans, nous fabriquons des voitures de course dans le but de participer à des compétitions, toujours avec le même objectif : remporter toutes les compétitions auxquelles nous participons. <br><br> ` +
          `Les véhicules qui sortent de notre atelier sont de plus en plus développés chaque année, et nous cherchons à pousser les limites de l'ingénierie toujours plus loin. <br><br> ` +
          `Notre troisième voiture électrique, nommée MANIC-23, ne pèse que 186 kg pour une puissance réglementaire de 80 kW ou 108 chevaux. Elle est propulsée par 4 moteurs-roue électriques avec une suspension sur mesure et un châssis en fibre de carbone. Cette combinaison permet d’atteindre de 0 à 100 km/h en 2.5 secondes et une accélération latérale jusqu'à 2.5G en virage.`,
        },
      team: {
        title: "L'équipe !",
        text: `Formule ETS est un club composé de plus de 30 membres tous passionné par la conception, l'ingénierie et la mécanique.<br><br> C'est pourquoi au sein de notre équipe vous pourrez retrouver une ambiance de solidarité et d'entraide. Si vous souhaitez nous aider n'hésitez pas à venir nous voir dans nos bureaux.<br><br> Pour en apprendre plus sur notre équipe aller dans la section "Léquipe".`,
      },
    },

    date: {
      mainTitle: "Dates importantes",
      title: {
        FSEAST: "Formula Student EAST",
        FSG: "Formula Student Germany",
        FSAA: "Formula Student Alpe Adria",
      },
      informations: "Plus d'informations",
      months: "Mois",
      days: "Jours",
      hours: "Heures",
      minutes: "Minutes",
      seconds: "Secondes",
      time: "{0} Jours {1} Heures {2} Minutes {3} Secondes",
    },

    other: {
      back: "Retour",
    },

    eastereggs: {
      phone:
        "Vous avez trouvé un easter egg. Mais nous avons besoin d'un clavier pour fonctionner :/",
    },

    404: {
      title: "Page non trouvée",
    },

    albums: {
      title: "Albums",
      title_aside: "Années",
      year: "Année",
    },

    team: {
      title: "L'équipe",
      teams: "Équipes",
      year: "Année",
      management: "Gestion",
      aerodynamic: "Aérodynamique",
      chassis: "Châssis",
      dynamics: "Dynamique du véhicule",
      control: "Contrôle",
      electronics: "Électronique",
      power_n_drive: "Groupe Motopropulseur",
      powertrain: "Groupe Motopropulseur",
      drivetrain: "Transmission",
      machining: "Usinage",
      sponsors_n_media: "Commanditaires & Média",
      external_relationship: "Relations externes et Logistique",
      logistics : "Logistique",
      driverless: "Logiciel et système autonome",
      statics: "Statique",
      roles: {
        captain: "Capitaine de l'équipe",
        "co-captaine": "Co-capitaine de l'équipe",
        "technical-director": "Directeur technique",
        "co-technical-director": "Co-directeur technique",
        "management-director": "Directeur de gestion",
        "head-aerodynamics": "Chef d'Aérodynamique",
        "lead-aerodynamics": "Responsable Aérodynamique",
        "head-chassis": "Chef de Châssis",
        "lead-chassis": "Responsable Châssis",
        "heade-dynamic": "Chef de Dynamique",
        "lead-dynamic": "Responsable Dynamique",
        "lead-control": "Responsable Contrôle",
        "head-electronic": "Chef d'Électronique",
        "lead-electronic": "Responsable Électronique",
        "head-media-sponsors": "Chef de Commanditaires & Média",
        "lead-external-relationship": "Responsable Relations Externes et Logistique",
        "head-power-drive": "Chef de Motopropulseur",
        "lead-powertrain": "Responsable Motopropulseur",
        "lead-drivetrain": "Responsable Transmission",
        "head-power-drive-elec": "Chef de Motopropulseur Électrique",
        "head-power-drive-meca": "Chef de Motopropulseur Mécanique",
        "lead-logistics": "Responsable Logistique",
        "lead-machining": "Responsable Usinage",
        "lead-driverless": "Responsable Logiciel et Conduite Autonome",
        "lead-driverless-mec": "Responsable Mécanique Conduite autonome",
        "lead-statics": "Responsable épreuves statiques",
        "treasurer": "Trésorier",
        "lead-business": "Responsable épreuve Business",
        "lead-cost": "Responsable épreuve Cost",
      },
    },

    videos: {
      title: "Vidéos",
    },

    sponsors: {
      button: "Devenez un partenaire",
      title: "La formule ETS propulsée par",
      diamond: "Diamant",
      gold: "Or",
      silver: "Argent",
      bronze: "Bronze",
      classic: "Classique"
    },

    project: {
      auto: "Automatique",
      stop: "Arrêter",
      default: {
        animation: "animation dynamique",
        label:
          "Faites défiler vers le bas pour lancer l'animation et voir notre prototype en 3D.",
      },
      text: {
        chassis: {
          title: "Châssis",
          label:
            "Entièrement conçu et fabriqué par Formule ETS. <br> La monocoque en fibre de carbone offre une combinaison optimale de sécurité pour le pilote. <br> Sa structure en nid d'abeille garantie un poids minime pour des performances maximales.",
        },
        drivetrain: {
          title: "Transmission",
          label:
            "Transmission par engrenage planétaire. <br> Fixée sur des porte-fusées en aluminium imprimé 3D conçus sur mesure et usinés sur machine 5-axes CNC à l’interne <br> Fournit la puissance mécanique du véhicule grâce à 4 moteurs-roues.",
        },
        powertrain: {
          title: "Motopropulseur",
          label:
            "Performances assurées par un accumulateur de 600V compacte et efficace <br> Refroidissement et boîtier d’onduleurs personnalisés intégrant plusieurs circuits imprimés conçus pour la surveillance des circuits haute tension.",
        },
        dynamics: {
          title: "Dynamique du véhicule",
          label:
            "Conduite réactive et agile grâce à la suspension découplée et la technologie DSSV. Étriers de frein, suspension double wishbone et culbuteurs entièrement conçus par les membres de Formule ETS.",
        },
        electronics: {
          title: "Électronique",
          label:
            "L’unité de commande de véhicule programmée (VCU) est façonnée par notre propre expertise. <br> Les performances de l’accumulateur sont optimisées par le système de gestion de batterie (BMS). <br> L’unité de gestion de l’alimentation (PMU) permet de surveiller l’alimentation de la voiture.",
        },
        aerodynamics: {
          title: "Aérodynamique",
          label:
            "Développement d'un ensemble aérodynamique optimisé et efficace pour gérer <br> les flux d'air autour de la voiture. <br> Amélioration des performances en exploitant l'effet de sol et en produisant une <br> force d'appui pour permettre des virages plus rapides. <br> Système de réduction de traînée à double action (DRS).",
        },
        thank: {
          title: "Relations Externes et Logistique",
          label:
            "Promotion du club et relations avec les partenaires. <br> Organisation d'évènements pour assurer la visibilité de l'équipe et de ses commanditaires <br> Gestion des réseaux sociaux et échange avec la communauté.",
        },
      },
    },

    "3dmodel": {
      textureLoading: "Chargement des textures",
      modelLoading: "Chargement du model",
    },

    contact: {
      contact: "Nous Joindre",
    },

    donate: {
      particular: {
        button: "Faire un don (particulier)",
        title: "Le don",
        text: `En cliquant sur le lien ci-dessus, vous serez transféré au site sécurisé du Fonds de développement de l'ÉTS. Afin d'effectuer un don en tant que particulier, assurez-vous de cocher "particulier" puis remplissez le formulaire.`,
        italic: "Nous sommes très reconnaissants de votre aide!",
      },

      sponsorship: {
        button: "Commandite (compagnie)",
        title: "LA COMMANDITE FINANCIÈRE",
        text: `En cliquant sur le lien ci-dessus, vous serez transféré au site sécurisé du Fonds de développement de l'ÉTS. Afin de commanditer la Formule ETS en tant que compagnie, assurez vous de cocher "corporatif"  puis remplissez le formulaire. Le lien ci-dessous  est notre document de commandite décrivant les bénéfices qui vous sont disponibles selon votre niveau de commandite.`,
        italic: "Au plaisir de travailler avec vous!",
        link: {
          message : "DOCUMENT DE COMMANDITE OFFICIEL",
          href : "static/pdf/FormuleETS_PlanDePartenariat_2026.pdf"
        },
      },
    },
  },
};

export default fr;
